// Section file — populated during component conversion.
// Sections: terms, privacy, refundPage, jobs, agent, common
import React from "react";

const lang = {
  terms: {
    title: "Términos de Servicio",
    intro: (
      <>
        Gracias por elegir <span className="text-instagram">RizzUp</span> LLC, d/b/a <span className="text-instagram">ViralGPT</span> ("<span className="text-instagram">ViralGPT</span>", "nosotros", "nos" o "nuestro") para tus servicios de crecimiento en redes sociales. Al acceder o usar nuestro sitio web en <span className="text-instagram">viralgpt.com</span> (el "Sitio") o cualquiera de nuestros servicios (los "Servicios"), aceptas quedar sujeto a los siguientes Términos de Servicio (el "Acuerdo").
      </>
    ),
    serviceDescription: (
      <>
        <strong>Descripción del Servicio:</strong> <span className="text-instagram">ViralGPT</span> es un sitio web que ofrece servicios de crecimiento en redes sociales para ayudarte a aumentar tus seguidores, tu interacción y tu presencia general en redes sociales. Nuestros Servicios incluyen, entre otros, gestión de cuentas, estrategias de crecimiento y analíticas.
      </>
    ),
    userConduct: (
      <>
        <strong>Conducta del Usuario:</strong> Aceptas usar el Sitio y los Servicios de acuerdo con todas las leyes, reglas y regulaciones aplicables. También aceptas no participar en ninguna de las siguientes actividades:
      </>
    ),
    conductList: [
      <>Violar cualquier ley, regla o regulación;</>,
      <>Hacerte pasar por cualquier persona o entidad, o declarar falsamente o tergiversar de otro modo tu afiliación con una persona o entidad;</>,
      <>Interferir con o interrumpir el Sitio o los Servicios, o cualquier servidor o red conectados al Sitio o los Servicios;</>,
      <>Participar en cualquier actividad que pueda dañar o causar perjuicio a <span className="text-instagram">ViralGPT</span>, el Sitio, los Servicios o cualquier otro usuario;</>,
      <>Publicar o transmitir cualquier contenido que sea ilegal, dañino, amenazante, abusivo, acosador, difamatorio, obsceno, de odio o de cualquier otro modo objetable;</>,
      <>Usar cualquier medio automatizado, incluyendo sin limitación, bots, spiders o scrapers, para acceder al Sitio o los Servicios;</>,
      <>Tergiversar la naturaleza o el contenido de cualquier información, producto o servicio proporcionado por <span className="text-instagram">ViralGPT</span>.</>,
    ],
    payment: (
      <>
        <strong>Pagos y Facturación:</strong> Al comprar nuestros Servicios, aceptas pagar de manera oportuna todas las tarifas asociadas a tu cuenta. <span className="text-instagram">ViralGPT</span> se reserva el derecho de modificar nuestros precios y prácticas de facturación en cualquier momento. Todas las tarifas no son reembolsables, y <span className="text-instagram">ViralGPT</span> se reserva el derecho de suspender o cancelar tu cuenta en cualquier momento y por cualquier motivo.
      </>
    ),
    ip: (
      <>
        <strong>Propiedad Intelectual:</strong> Todo el contenido del Sitio y los Servicios, incluyendo sin limitación, texto, gráficos, logotipos, imágenes, software y código, es propiedad de <span className="text-instagram">ViralGPT</span> y está protegido por las leyes de derechos de autor y marcas registradas de Estados Unidos e internacionales. No puedes copiar, reproducir, distribuir ni crear obras derivadas basadas en ningún contenido sin el consentimiento previo por escrito de <span className="text-instagram">ViralGPT</span>.
      </>
    ),
    warranties: (
      <>
        <strong>Exención de Garantías:</strong> EL SITIO Y LOS SERVICIOS SE PROPORCIONAN "TAL CUAL" Y SIN GARANTÍAS DE NINGÚN TIPO, YA SEAN EXPRESAS O IMPLÍCITAS, INCLUYENDO, ENTRE OTRAS, LAS GARANTÍAS IMPLÍCITAS DE COMERCIABILIDAD E IDONEIDAD PARA UN PROPÓSITO PARTICULAR. <span className="text-instagram">ViralGPT</span> NO GARANTIZA QUE EL SITIO O LOS SERVICIOS SERÁN ININTERRUMPIDOS O ESTARÁN LIBRES DE ERRORES, QUE LOS DEFECTOS SERÁN CORREGIDOS, NI QUE EL SITIO O LOS SERVIDORES QUE LO HACEN DISPONIBLE ESTÉN LIBRES DE VIRUS U OTROS COMPONENTES DAÑINOS.
      </>
    ),
    liability: (
      <>
        <strong>Limitación de Responsabilidad:</strong> <span className="text-instagram">ViralGPT</span> NO SERÁ RESPONSABLE DE NINGÚN DAÑO DIRECTO, INDIRECTO, INCIDENTAL, ESPECIAL, CONSECUENTE O EJEMPLAR, INCLUYENDO, ENTRE OTROS, DAÑOS POR PÉRDIDA DE GANANCIAS, FONDO DE COMERCIO, USO, DATOS U OTRAS PÉRDIDAS INTANGIBLES (INCLUSO SI <span className="text-instagram">ViralGPT</span> HA SIDO ADVERTIDO DE LA POSIBILIDAD DE DICHOS DAÑOS), QUE RESULTEN DE TU USO DEL SITIO O LOS SERVICIOS.
      </>
    ),
    indemnification: (
      <>
        <strong>Indemnización:</strong> Aceptas defender, indemnizar y mantener indemne a <span className="text-instagram">ViralGPT</span>, sus afiliadas y sus respectivos directores, funcionarios, empleados y agentes frente a todo reclamo, daño, obligación, pérdida, responsabilidad, costo o deuda, y gasto (incluyendo entre otros honorarios de abogados) que surja de tu uso del Sitio o los Servicios, tu violación de estos Términos de Servicio o tu violación de cualquier derecho de terceros.
      </>
    ),
    cancellation: (
      <>
        <strong>Política de Cancelación:</strong> Puedes cancelar tu suscripción en cualquier momento contactándonos en <span className="text-instagram">support@viralgpt.com</span>. Las cancelaciones serán efectivas al final del ciclo de facturación actual. No se otorgarán reembolsos por ninguna porción no utilizada de tu suscripción.
      </>
    ),
    refundPolicy: (
      <>
        <strong>Política de Reembolso:</strong> Ofrecemos una garantía de devolución de dinero de 7 días para nuestros Servicios. Si no estás satisfecho con nuestros Servicios dentro de los primeros 7 días de tu suscripción, puedes solicitar un reembolso completo contactándonos en <span className="text-instagram">support@viralgpt.com</span>. Los reembolsos se procesarán dentro de 7 días hábiles.
      </>
    ),
    contact: (
      <>
        <strong>Información de Contacto:</strong> Si tienes alguna pregunta o inquietud sobre estos Términos de Servicio, contáctanos en <span className="text-instagram">support@viralgpt.com</span>.
      </>
    ),
    agreement: (
      <>
        Al usar el Sitio o los Servicios, aceptas estos Términos de Servicio. Si no estás de acuerdo con estos Términos de Servicio, no puedes usar el Sitio ni los Servicios. Nos reservamos el derecho de modificar estos Términos de Servicio en cualquier momento, y dichas modificaciones serán efectivas inmediatamente después de su publicación en el Sitio. Tu uso continuado del Sitio o los Servicios después de cualquier modificación a estos Términos de Servicio constituirá tu aceptación de dichas modificaciones.
      </>
    ),
  },

  privacy: {
    title: "Política de Privacidad",
    intro: (
      <>
        Gracias por elegir <span className="text-instagram">RizzUp</span> LLC, d/b/a <span className="text-instagram">ViralGPT</span> ("<span className="text-instagram">ViralGPT</span>", "nosotros", "nos" o "nuestro") para tus servicios de crecimiento en redes sociales. Proteger tu privacidad es importante para nosotros. Esta Política de Privacidad explica cómo recopilamos, usamos y divulgamos tu información personal.
      </>
    ),
    infoCollect: (
      <>
        <strong>Información que Recopilamos:</strong> Recopilamos la información personal que nos proporcionas cuando creas una cuenta, compras nuestros Servicios o te comunicas con nosotros. Esto puede incluir tu nombre, dirección de correo electrónico, dirección de facturación e información de pago. También recopilamos información no personal como tu dirección IP, tipo de navegador y sistema operativo cuando visitas nuestro Sitio o usas nuestros Servicios.
      </>
    ),
    howWeUse: (
      <>
        <strong>Cómo Usamos tu Información:</strong> Usamos tu información personal para brindarte nuestros Servicios, procesar tus pagos, comunicarnos contigo sobre tu cuenta y enviarte materiales promocionales. También usamos información no personal para analizar patrones de uso en nuestro Sitio y mejorar nuestros Servicios.
      </>
    ),
    sharing: (
      <>
        <strong>Cómo Compartimos tu Información:</strong> No vendemos, intercambiamos ni alquilamos tu información personal a terceros. Podemos divulgar tu información personal a nuestros proveedores de servicios de confianza que nos ayudan a brindar nuestros Servicios, como procesadores de pago y proveedores de correo electrónico. Exigimos a estos proveedores de servicios que protejan tu información personal y que solo la usen para los fines para los que fue divulgada. También podemos divulgar tu información personal si lo exige la ley o en respuesta a una orden judicial, citación u otro proceso legal.
      </>
    ),
    retention: (
      <>
        <strong>Retención de Datos:</strong> Conservamos tu información personal durante el tiempo que sea necesario para brindarte nuestros Servicios y durante el tiempo que lo exija la ley.
      </>
    ),
    security: (
      <>
        <strong>Seguridad:</strong> Tomamos medidas razonables para proteger tu información personal contra el acceso, la divulgación o la alteración no autorizados. Sin embargo, ningún método de transmisión por Internet o de almacenamiento electrónico es completamente seguro, y no podemos garantizar la seguridad absoluta de tu información personal.
      </>
    ),
    children: (
      <>
        <strong>Privacidad de los Niños:</strong> Nuestro Sitio y Servicios no están dirigidos a niños menores de 13 años. No recopilamos a sabiendas información personal de niños menores de 13 años. Si eres padre, madre o tutor y crees que tu hijo nos ha proporcionado información personal, contáctanos en <span className="text-instagram">support@viralgpt.com</span>.
      </>
    ),
    changes: (
      <>
        <strong>Cambios a esta Política de Privacidad:</strong> Podemos actualizar esta Política de Privacidad de vez en cuando. Publicaremos la Política de Privacidad actualizada en nuestro Sitio e indicaremos la fecha de la última revisión. Tu uso continuado de nuestro Sitio o Servicios después de que se publique la Política de Privacidad actualizada constituirá tu aceptación de la Política de Privacidad actualizada.
      </>
    ),
    contact: (
      <>
        <strong>Información de Contacto:</strong> Si tienes alguna pregunta o inquietud sobre esta Política de Privacidad, contáctanos en <span className="text-instagram">support@viralgpt.com</span>.
      </>
    ),
    agreement: (
      <>
        Al usar nuestro Sitio o Servicios, aceptas esta Política de Privacidad. Si no estás de acuerdo con esta Política de Privacidad, no puedes usar nuestro Sitio ni nuestros Servicios.
      </>
    ),
  },

  refundPage: {
    title: "Política de Reembolso",
    intro: (
      <>
        Ofrecemos una garantía de devolución de dinero de 7 días para nuestros Servicios. Si no estás satisfecho con nuestros Servicios dentro de los primeros 7 días de tu compra, puedes solicitar un reembolso completo contactándonos en{" "}
        <span className="text-instagram">support@viralgpt.com</span>. Los reembolsos se procesarán dentro de 7 días hábiles.
      </>
    ),
    lookupTitle: "Búsqueda de Transacciones",
    emailPlaceholder: "Ingresa tu dirección de correo electrónico",
    lookupOrders: "Buscar Pedidos",
    lookupFailed: "No se pudieron buscar las transacciones",
    requestError: "Hubo un error al procesar tu solicitud",
    historyTitle: "Historial de Transacciones",
    blockedBinNotice: (
      <>
        Este método de pago debe reembolsarse manualmente. Por favor escribe a <a href="mailto:support@viralgpt.com" className="link-blue">support@viralgpt.com</a> y nuestro equipo se encargará de ti.
      </>
    ),
    thDate: "Fecha",
    thType: "Tipo",
    thAmount: "Monto",
    thAction: "Acción",
    txTypes: {
      initial: "Inicial",
      recurring: "Recurrente",
      refill: "Recarga",
      upsell: "Mejora",
      invoice: "Factura",
      "change-plan": "Cambio de Plan",
      topup: "Recarga de Saldo",
      spin: "Giros",
      subcharge: "Suscripción",
    },
    requestRefund: "Solicitar Reembolso",
    blockedBinTitle: "Escribe a support@viralgpt.com para reembolsar esta tarjeta.",
    refillHint: "¿Te faltan seguidores? Los recargamos gratis —",
    refillLink: "solicitar recarga",
    cancelHint: "¿Solo quieres detener los cobros? —",
    cancelLink: "cancelar tu suscripción",
    reviewNote: "Revisaremos tu solicitud de reembolso y tu elegibilidad para nuestra garantía de devolución de dinero de 7 días.",
    immediateAssistance: (
      <>
        Para asistencia inmediata, contáctanos en <a href="mailto:support@viralgpt.com" className="link-blue">support@viralgpt.com</a>
      </>
    ),
    reasonLabel: "Motivo del reembolso",
    selectReason: "Selecciona un motivo...",
    optAccidentalAnnual: "Compré el plan anual por accidente",
    optMissingFollowers: "Seguidores Faltantes",
    optOther: "Otro",
    switchTitle: "Cambiar a Facturación Mensual",
    switchDesc: (refundDiff, price, monthlyPrice, planLabel) => (
      <>
        Te reembolsaremos <strong>${refundDiff}</strong> (la diferencia entre tu cargo anual de ${price} y ${monthlyPrice}/mes) y cambiaremos tu plan <strong>{planLabel}</strong> a facturación mensual.
      </>
    ),
    annualChargePaid: "Cargo anual pagado",
    newMonthlyRate: "Nueva tarifa mensual",
    perMo: (p) => `$${p}/mes`,
    refundAmountLabel: "Monto del reembolso",
    noOriginalTx: "No se pudo encontrar la transacción original.",
    switchSuccess: (refundAmount, newMonthlyPrice, dateStr) =>
      `¡Listo! Se te reembolsaron $${refundAmount} y cambiaste a $${newMonthlyPrice}/mes. Tu próximo cargo es el ${dateStr}.`,
    somethingWrong: "Algo salió mal. Por favor contacta a support@viralgpt.com.",
    processing: "Procesando...",
    switchBtn: (refundDiff) => `Reembolsar $${refundDiff} y Cambiar a Mensual`,
    refillFree: "¡Podemos reponer tus seguidores faltantes gratis!",
    goToRefill: "Ir a la Página de Reposición",
    detailsLabel: "Por favor danos más detalles",
    detailsPlaceholder: "Por favor describe por qué solicitas un reembolso",
    detailsHelp: "Por favor proporciona un motivo detallado para ayudarnos a procesar tu solicitud.",
    submitting: "Enviando...",
    submitRequest: "Enviar Solicitud",
    enterReason: "Por favor ingresa un motivo para tu solicitud de reembolso.",
    submitSuccess: "Solicitud de reembolso enviada con éxito. La procesaremos dentro de 24 horas.",
    submitError: "Hubo un error al procesar tu solicitud de reembolso. Por favor intenta de nuevo o contacta a soporte.",
    subscriptionTitle: "Tu Suscripción",
    subPlanLabel: "Plan",
    subPriceLabel: "Precio",
    subNextChargeLabel: "Próximo cobro",
    intervalMonthly: "Mensual",
    intervalAnnual: "Anual",
    cancelSubscription: "Cancelar Suscripción",
    keepSubscription: "Mantener Suscripción",
    confirmCancel: "Cancelar Suscripción",
    canceling: "Cancelando...",
    cancelWhy: "Lamentamos que te vayas. Cuéntanos por qué cancelas — quizá podamos solucionarlo.",
    cancelReasonLabel: "Motivo de la cancelación",
    cancelOptPriceTooHigh: "El precio es muy alto",
    cancelOptNotUsing: "No lo uso lo suficiente",
    cancelDetailsPlaceholder: "Por favor cuéntanos por qué cancelas",
    cancelSelectReason: "Por favor selecciona un motivo para cancelar.",
    cancelDetailsRequired: "Por favor cuéntanos por qué cancelas.",
    cancelAccessNote: (dateStr) => `No se te volverá a cobrar. Tu plan y tu crecimiento siguen activos hasta el ${dateStr}.`,
    cancelAccessNoteNoDate: "No se te volverá a cobrar. Tu plan sigue activo hasta el final de tu periodo de facturación actual.",
    cancelSuccess: (dateStr) => `Tu suscripción ha sido cancelada. No se te volverá a cobrar y conservas el acceso hasta el ${dateStr}.`,
    cancelSuccessNoDate: "Tu suscripción ha sido cancelada. No se te volverá a cobrar.",
    alreadyCanceled: (dateStr) => `Esta suscripción ya está cancelada. Conservas el acceso hasta el ${dateStr}.`,
    alreadyCanceledNoDate: "Esta suscripción ya está cancelada.",
    subProfileLabel: "Cuenta",
    refillSubTitle: "Suscripción de Recarga Automática",
    refillSubPrice: (amount, days) => `$${amount} cada ${days} días`,
    cancelAutoRefill: "Cancelar Recarga Automática",
    cancelAutoRefillNote: "Esto detiene el cobro recurrente de recarga automática. Las recargas ya entregadas no se ven afectadas.",
    autoRefillCanceled: "Tu suscripción de recarga automática ha sido cancelada. No se te volverá a cobrar.",
    autoRefillAlreadyCanceled: "Esta suscripción de recarga automática ya está cancelada. No se te volverá a cobrar.",
  },

  cancelPortal: {
    title: "Cancela Tu Suscripción",
    intro: "Ingresa el correo de tu cuenta para encontrar tus suscripciones y cancelar en un clic. No necesitas iniciar sesión.",
    lookupTitle: "Encuentra Tus Suscripciones",
    findSubscriptions: "Buscar Mis Suscripciones",
    nothingToCancel: "No encontramos una suscripción activa para este correo. Si crees que es un error, contacta a support@viralgpt.com.",
    refillHint: "¿Te faltan seguidores? Los recargamos gratis —",
    refillLink: "solicitar recarga",
    refundHint: "¿Buscas un reembolso? —",
    refundLink: "abrir el formulario de reembolso",
  },

  refillPortal: {
    title: "Recarga Seguidores Perdidos",
    intro: "Los seguidores perdidos se recargan gratis. Ingresa el correo de tu cuenta, escanea tu perfil y lo restauramos.",
    lookupTitle: "Encuentra Tus Cuentas",
    findAccounts: "Buscar Mis Cuentas",
    noProfiles: "No encontramos una red social vinculada a este correo. Contacta a support@viralgpt.com y te ayudamos.",
    selectProfile: "Selecciona la cuenta a escanear",
    chooseProfile: "Elige una cuenta...",
    scanProfile: "Escanear Seguidores Perdidos",
    scanning: "Escaneando...",
    scanResults: "Resultados del Escaneo",
    scanFailed: "No pudimos escanear esta cuenta en este momento. Por favor intenta de nuevo en unos minutos.",
    requestFailed: "No pudimos enviar tu recarga. Por favor intenta de nuevo o contacta a support@viralgpt.com.",
    expected: "Seguidores esperados",
    current: "Seguidores actuales",
    missing: "Faltantes",
    requestRefill: (count) => `Recargar ${count} Seguidores Gratis`,
    submitting: "Enviando...",
    noneMissing: (count) => `No faltan seguidores — tu cuenta tiene ${count} seguidores, igual o por encima de lo que entregamos.`,
    claimed: "Tu recarga está en camino. Los seguidores suelen restaurarse en 24 horas.",
    deliveredTitle: "Cumplimos Nuestra Promesa",
    summaryTitle: "Tu Cuenta",
    stillDelivering: "Aún en entrega",
    inFlightNote: (count) => `Tu pedido está en camino — ${count} seguidores aún se están entregando. La mayoría de los pedidos terminan en 24 horas.`,
    startedWith: "Seguidores cuando empezaste",
    youPurchased: "Seguidores que compraste",
    rightNow: "Seguidores ahora mismo",
    deliveredNote: (delivered, gained) => `Entregamos ${delivered} seguidores a tu cuenta y has subido ${gained} seguidores desde que empezaste con nosotros. No falta nada — ¡todo en orden!`,
    deliveredNoteShort: (delivered, now) => `Entregamos ${delivered} seguidores a tu cuenta y hoy estás en ${now} seguidores.`,
    helpNote: "¿No es lo que esperabas? Escríbenos y lo resolvemos:",
    summaryNote: (now) => `Tu cuenta está en ${now} seguidores y todo se ve bien. Todavía no vemos un pedido de seguidores en esta cuenta.`,
    shortfallNote: (count) => `Tu conteo está unos ${count} por debajo de lo que entregamos. Las plataformas eliminan cuentas inactivas con el tiempo — reclama tu recarga gratuita abajo.`,
    settlingNote: (count) => `Tu cuenta está ${count} por debajo de lo que entregamos. Los pedidos recientes aún se están asentando y las plataformas pierden algunos seguidores los primeros días, así que esto suele resolverse solo — vuelve en unos días y te recargamos gratis si no es así.`,
    limitNote: "Se puede solicitar una recarga cada 24 horas por cuenta.",
  },

  jobs: {
    greeting: "HOLA LISETTE",
    title: "EMPLEOS",
    searchLabel: "Buscar Empleos:",
    searchPlaceholder: "Ingresa un puesto o ubicación",
    noJobs: "No se encontraron empleos.",
    loadFailed: "No se pudieron cargar los empleos.",
    company: "Empresa:",
    location: "Ubicación:",
    applyHere: "Postúlate Aquí",
    previous: "Anterior",
    next: "Siguiente",
    pageN: (n) => `Página ${n}`,
  },

  agent: {
    headerTitle: "Agente CRO",
    headerSubtitle: "Inteligencia de Rendimiento de ViralGPT",
    sendReport: "Enviar Reporte",
    reportSent: "¡Reporte diario enviado a Discord!",
    reportFailed: (msg) => `Falló: ${msg}`,
    tabAgent: "Agente",
    tabData: "Datos",
    readyTitle: "Agente CRO Listo",
    readyDesc: "Puedo consultar tu base de datos, navegar tu sitio web con Chrome headless, acceder a herramientas de administración y gestionar usuarios/suscripciones (con tu aprobación).",
    daysContext: (d) => `Contexto ${d}D`,
    analyzing: "Analizando...",
    inputPlaceholder: "Pregunta sobre tu embudo, gasto en anuncios, tasas de conversión...",
    agentUsedTools: (n) => `El agente usó ${n} herramienta${n > 1 ? "s" : ""}:`,
    errorLabel: "Error:",
    requestFailed: "La solicitud falló.",
    loadingData: "Cargando datos...",
    sections: {
      overview: "Resumen",
      funnel: "Embudo",
      revenue: "Ingresos",
      costs: "Costos y P/G",
      performance: "Rendimiento",
    },
    viewLabels: {
      daily: "diario",
      weekly: "semanal",
      monthly: "mensual",
    },
    dateLabels: {
      daily: "Fecha",
      weekly: "Semana",
      monthly: "Mes",
    },
    cardLabels: {
      adSpend: "Gasto en Anuncios",
      grossRevenue: "Ingresos Brutos",
      netProfit: "Ganancia Neta",
      roas: "ROAS",
      cpa: "CPA",
      cpc: "CPC",
      newSubs: "Subs Nuevas",
      lpToPurchase: "LP→Compra",
      annualPct: "% Anual",
      views: "Vistas",
      addToCart: "Agregar al Carrito",
      registrations: "Registros",
      checkouts: "Checkouts",
      purchases: "Compras",
      lpToAtc: "LP→ATC",
      atcToReg: "ATC→Reg",
      regToChk: "Reg→Chk",
      chkToPur: "Chk→Pur",
      lpToPur: "LP→Pur",
      initialRevenue: "Ingresos Iniciales",
      recurringRevenue: "Ingresos Recurrentes",
      topupRevenue: "Ingresos por Recargas",
      annualPurchases: "Compras Anuales",
      monthlyPurchases: "Compras Mensuales",
      annualRatio: "Proporción Anual",
      subCosts: "Costos de Subs (10%)",
      productCosts: "Costos de Producto (5%)",
      fees: "Comisiones (5%)",
      refunds: "Reembolsos (15%)",
      chargebacks: "Contracargos (15%)",
      margin: "Margen",
    },
    tableHeaders: {
      overview: ["Gasto", "Vistas", "Comp", "Bruto", "Neto", "ROAS", "CPA", "CPC", "LP→Pur", "An%"],
      funnel: ["Vistas", "ATC", "Reg", "Chkout", "Comp", "LP→ATC", "ATC→Reg", "Reg→Chk", "Chk→Pur", "LP→Pur"],
      revenue: ["Subs", "Inicial", "Recurrente", "Recargas", "Bruto", "An", "Men", "An%", "ROAS"],
      costs: ["Gasto", "Bruto", "Sub 10%", "Prod 5%", "Com 5%", "Reemb 15%", "CB 15%", "Neto", "Margen"],
      performance: ["Gasto", "Vistas", "Comp", "CPC", "CPA", "ROAS", "LP→ATC", "Chk→Pur", "LP→Pur"],
    },
    legendExceeds: "Supera el punto de referencia",
    legendMeets: "Cumple el punto de referencia",
    legendBelow: "Debajo del punto de referencia",
    resolved: "Resuelto",
    requiresApproval: "La Acción Requiere Aprobación",
    approve: "Aprobar",
    reject: "Rechazar",
    approvedResult: (r) => `Aprobado: ${r}`,
    rejected: "Rechazado",
    errorResult: (m) => `Error: ${m}`,
    quickPrompts: {
      fullFunnelAudit: "Auditoría Completa del Embudo",
      annualVsMonthly: "Anual vs Mensual",
      cpcRoas: "CPC y ROAS",
      dailyTrends: "Tendencias Diarias",
      scaleReadiness: "Preparación para Escalar",
      revenueLeaks: "Fugas de Ingresos",
      activeSubscribers: "Suscriptores Activos",
      cohortAnalysis: "Análisis de Cohortes",
    },
  },

  common: {
    cancel: "Cancelar",
    loading: "Cargando...",
  },
};

export default lang;
